import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlAdvertenciaFornecedor = '/service/materiais/adverteFornecedor/'

class ConsultaAdvertenciaFornecedorService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            nome: filtro.nome ? filtro.nome : null,
            cpf: filtro.cpf ? filtro.cpf.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4') : null,
            cnpj: filtro.cnpj ? filtro.cnpj.replace(/^(\d{2}).(\d{3}).(\d{3})\/(\d{4})-(\d{2})/, '$1$2$3$4$5') : null,
            penalidadeVigente: 'S',
        }
        return this.conex.post(urlAdvertenciaFornecedor + 'consultaAdvertenciaFornecedor/', JSON.stringify(data))
    }

    consultarSancoes(filtro) {
        let data = {
            nome: filtro.nome ? filtro.nome : null,
            cpf: filtro.cpf ? filtro.cpf.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4') : null,
            cnpj: filtro.cnpj ? filtro.cnpj.replace(/^(\d{2}).(\d{3}).(\d{3})\/(\d{4})-(\d{2})/, '$1$2$3$4$5') : null,
            penalidadeVigente: null,
        }
        return this.conex.post(urlAdvertenciaFornecedor + 'consultaAdvertenciaFornecedor/', JSON.stringify(data))
    }
}

export default ConsultaAdvertenciaFornecedorService
